import React from 'react';
import styles from '../furnishingContainer.module.scss';

interface SectionHeaderProps {
  title: string;
  buttonText: string;
  onButtonClick: () => void;
  disabled?: boolean;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  buttonText,
  onButtonClick,
  disabled
}) => {
  return (
    <div className={styles['furnishing-management__subsection-header']}>
      <h5>{title}</h5>
      <button
        type="button"
        onClick={onButtonClick}
        className={styles['furnishing-management__add-btn']}
        disabled={disabled}
      >
        {buttonText}
      </button>
    </div>
  );
};
